export const IN_YOUR_GARAGE_TEXT = 'In Your Garage'
export const VEHICLE_TEXT = 'Vehicle'
